export const isFormDirty = (initialValues, currentValues) => {
  if (!initialValues || !currentValues) return false;

  const isEqual = (val1, val2) => {
    // Normalize null/undefined to empty string
    const v1 = val1 ?? "";
    const v2 = val2 ?? "";

    if (v1 === v2) return true;

    // Type Normalization: Treat numbers and numeric strings as same (e.g., 5.5 === "5.5")
    const isV1Numeric = typeof v1 === "number" || (typeof v1 === "string" && v1.trim() !== "" && !isNaN(v1));
    const isV2Numeric = typeof v2 === "number" || (typeof v2 === "string" && v2.trim() !== "" && !isNaN(v2));

    if (isV1Numeric && isV2Numeric) {
      return Number(v1) === Number(v2);
    }

    // Array Deep Comparison
    if (Array.isArray(v1) && Array.isArray(v2)) {
      if (v1.length !== v2.length) return false;
      return v1.every((item, index) => isEqual(item, v2[index]));
    }

    // Object Deep Comparison
    if (typeof v1 === "object" && typeof v2 === "object" && v1 !== null && v2 !== null) {
      const keys1 = Object.keys(v1);
      const keys2 = Object.keys(v2);
      if (keys1.length !== keys2.length) return false;
      return keys1.every(key => isEqual(v1[key], v2[key]));
    }

    // Fallback for strings
    return String(v1).trim() === String(v2).trim();
  };

  // Check if any key in currentValues is different from initialValues
  const keys = Object.keys(currentValues);
  for (const key of keys) {
    if (!isEqual(initialValues[key], currentValues[key])) {
      return true;
    }
  }

  return false;
};